import { useDataChange, useDataOriginalValue } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'provider_accounts',
    viewPath: props.viewPath,
  })

  let original = useDataOriginalValue({
    context: 'provider_accounts',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext[props.index] = {
        ...next,
        has_changes:
          next.fee_mode !== original[props.index].fee_mode ||
          next.card_fee_percent !== original[props.index].card_fee_percent ||
          next.ach_fee_percent !== original[props.index].ach_fee_percent ||
          next.greyfinch_pay_app_enabled !==
            original[props.index].greyfinch_pay_app_enabled,
      }
    })
  }
}
